import Greeting from "./Greeting";

export default Greeting;
